export default __webpack_public_path__ + "static/media/image55.c49936c0.jpg";